import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_team_management-insider_marketing_page_insufficient_permissions_tooltip-view';
/**
 * Tooltip if user without checkout permissions tries to click enroll in insider
 */
export function trackRetailerTeamManagementInsiderMarketingPageInsufficientPermissionsTooltipView() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
